<template>
  <div class="footer">
    <div class="make">
      <div class="make-content">
        <div class="make-left">
          <div class="title">
            可以预约小语种老师与您联系<br>预约面谈时间，了解各种学习问题
          </div>
          <div class="input">
            <div class="label">
              输入您想了解的问题
            </div>
            <textarea type="text" v-model="form.content" class="left-input" />
          </div>
        </div>
        <div class="make-right">
          <div class="top">
            <div class="form-item">
              <div class="label">您的姓名</div>
              <input type="text" class="right-input" v-model="form.name">
            </div>
            <div class="form-item">
              <div class="label">您的手机号</div>
              <input type="text" class="right-input" v-model="form.phone">
            </div>
          </div>
          <div class="bottom" @click="onSubmit()">
            <div class="btn"><i></i> 在线预约</div>
          </div>
        </div>
      </div>
    </div>
    <div class="environ">
      <div class="consult-title"><span class="e75">校区环境</span></div>
      <div class="environ-img">
        <img src="../assets/static/environ.png" alt="">
      </div>
    </div>
    <footer>
      小语种报名咨询热线：400-883-5918
    </footer>
  </div>
</template>

<script >
export default {
  data() {
    return {
      form: {
        name: "",
        phone: "",
        content: ""
      }
    }
  },
  methods: {
    onSubmit() {
      if (!this.form.content.trim()) return this.$message.warning("请输入您想了解的问题")
      this.$emit('submit', this.form)
    }

  }
}
</script>

<style lang="scss" scoped>
.footer {
  .make {
    height: 360px;
    background-color: #ffba2e;
    margin-top: 110px;
    .make-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      height: 100%;
      padding: 54px 50px;
      .label {
        font-size: 24px;
        color: #333;
        font-weight: 500;
      }
      .make-left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          color: #333333;
          font-size: 30px;
          font-weight: 500;
        }

        .input {
          .left-input {
            height: 98px;
            width: 564px;
            font-size: 20px;
            line-height: 30px;
            padding: 12px;
            border-radius: 11px;
            margin-top: 20px;
          }
        }
      }

      .make-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 60px;
        .top {
          .form-item {
            display: flex;
            margin-bottom: 20px;
            .label {
              text-align: right;
              margin-right: 12px;
            }

            .right-input {
              background-color: transparent;
              border-bottom: #122753 solid 2px;
              font-size: 18px;
            }
          }
        }

        .bottom {
          display: flex;
          justify-content: center;
          .btn {
            display: flex;
            align-items: center;
            cursor: pointer;
            width: 240px;
            height: 72px;
            background-color: #ffffff;
            box-shadow: 0px 3px 2px 0px rgba(134, 138, 183, 0.24);
            border-radius: 36px;
            border: solid 2px #ffffff;
            color: #122753;
            font-size: 30px;
            padding-left: 6px;
            i {
              height: 60px;
              width: 60px;
              background: url("../assets/static/btn/btn3.png") no-repeat;
              background-size: 100% 100%;
              margin-right: 15px;
            }
          }
        }
      }
    }
  }
  .environ {
    margin: 0 auto;
    margin-top: 80px;

    .environ-img {
      margin: 58px auto 0;
      width: 1176px;
      height: 240px;
    }
  }
  footer {
    margin-top: 80px;
    height: 100px;
    line-height: 100px;
    background-color: #e8354b;
    text-align: center;
    font-size: 30px;
    color: #ffffff;
    font-family: gb;
    font-weight: 600;
  }
}
input,
textarea {
  outline: none;
  border: none;
  resize: none;
}
.consult-title {
  font-size: 48px;
  font-family: gb;
  font-weight: 600;
  color: #122753;
  text-align: center;
  span {
    font-family: gb;
    font-weight: 600;
  }
}
</style>
